import { TypedDocumentNode, gql } from '@apollo/client';

import {
  isMyCardListedOnMarket,
  isSentInDirectOffer,
} from '@sorare/core/src/lib/cards';

import { useCardsHaveWarning_anyCard } from './__generated__/useCardsHaveWarning.graphql';

type Props = {
  cards: useCardsHaveWarning_anyCard[];
  so5FixtureSlug: string;
  so5LineupId: string;
};

export const useCardsHaveWarning = ({
  cards,
  so5FixtureSlug,
  so5LineupId,
}: Props) => {
  const listedOnMarketCards = cards.filter(card =>
    isMyCardListedOnMarket(card)
  );
  const sentInDirectOfferCards = cards.filter(card =>
    isSentInDirectOffer(card)
  );
  const usedInOtherLineupCards = cards.filter(anyCard =>
    anyCard.openedSo5Lineups.some(
      l => l.so5Fixture.slug === so5FixtureSlug && l.id !== so5LineupId
    )
  );

  return (
    listedOnMarketCards.length +
      sentInDirectOfferCards.length +
      usedInOtherLineupCards.length >
    0
  );
};

useCardsHaveWarning.fragments = {
  anyCard: gql`
    fragment useCardsHaveWarning_anyCard on AnyCardInterface {
      slug
      openedSo5Lineups {
        id
        so5Fixture {
          slug
        }
      }
      ...isMyCardListedOnMarket_anyCard
      ...isSentInDirectOffer_anyCard
    }
    ${isMyCardListedOnMarket.fragments.anyCard}
    ${isSentInDirectOffer.fragments.anyCard}
  ` as TypedDocumentNode<useCardsHaveWarning_anyCard>,
};
